<template>
    <div class="container-fluid">
        <Breadcrumb title="PMTA Relays Report" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group">
                            <label>Relay Type</label>
                            <treeselect v-model="filter.isVps" placeholder="Type"
                                        :clearable=false
                                        :multiple="false"
                                        :options="relayTypeSelect"/>
                        </div>
                        <div class="input-group form-group">
                            <label>Relay Group</label>
                            <treeselect v-model="filter.relayGroup" placeholder="All Relays"
                                        :multiple="false"
                                        :options="relayGroupList"
                                        :load-options="loadRelayGroupList"
                                        :auto-load-root-options="true"/>
                        </div>
                        <div class="input-group form-group">
                            <label>Date Range</label>
                            <date-picker v-model="range" range style="width:100%;" :lang="datePickerConf"></date-picker>
                        </div>
                        <div class="form-row">
                            <div class="col-2">
                                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light w-100"
                                        @click="getRelaysReport()">
                                    Get
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="report.length === 0">{{emptyMessage}}</div>
                            <div v-else>
                                <div>
                                    <div id="relayReportHtml" v-show="false">
                                        <div class="table-responsive">
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                <tr>
                                                    <th>Provider</th>
                                                    <th>Delivered</th>
                                                    <th>Bounced</th>
                                                    <th>Views</th>
                                                    <th>Clicks</th>
                                                    <th>Conv</th>
                                                    <th>Profit</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(provider, index) in relayReport" :key="index">
                                                    <td>{{provider.name}}</td>
                                                    <td>{{provider.delivered}}</td>
                                                    <td>{{provider.bounced}}</td>
                                                    <td>{{provider.views}}</td>
                                                    <td>{{provider.clicks}}</td>
                                                    <td>{{provider.conversions}}</td>
                                                    <td>{{provider.profit}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th @click="tableOrdering('id')">
                                                    <span role='button'>ID</span>
                                                </th>
                                                <th @click="tableOrdering('username')" v-if="isAdmin">
                                                    <span role='button'>Owner</span>
                                                </th>
                                                <th @click="tableOrdering('isVps')">
                                                    <span role='button'>Type</span>
                                                </th>
                                                <th @click="tableOrdering('ip')">
                                                    <span role='button'>IP</span>
                                                </th>
                                                <th @click="tableOrdering('host')">
                                                    <span role='button'>Hostname</span>
                                                </th>
                                                <th @click="tableOrdering('delivered')">
                                                    <span role='button'>Delivered</span>
                                                </th>
                                                <th @click="tableOrdering('bounced')">
                                                    <span role='button'>Bounced</span>
                                                </th>
                                                <th @click="tableOrdering('views')">
                                                    <span role='button'>Views</span>
                                                </th>
                                                <th @click="tableOrdering('clicks')">
                                                    <span role='button'>Clicks</span>
                                                </th>
                                                <th @click="tableOrdering('conversions')">
                                                    <span role='button'>Conv</span>
                                                </th>
                                                <th @click="tableOrdering('profit')">
                                                    <span role='button'>Profit</span>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(relay, index) in report" :key="index">
                                                <td class="align-middle">{{relay.id}}</td>
                                                <td class="align-middle" v-if="isAdmin">{{relay.username}}</td>
                                                <td class="align-middle">{{relay.isVps ? 'VPS' : 'Net'}}</td>
                                                <td class="align-middle">{{relay.ip}}</td>
                                                <td class="align-middle">
                                                    <span id='relay-host' role='button'
                                                          @click="getRelayReport(relay.id, relay.host)">
                                                        {{relay.host}}
                                                    </span>
                                                    <div v-if="waitRelay === relay.id"
                                                         class="spinner-grow spinner-grow-sm" role="status">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                </td>
                                                <td class="align-middle">{{relay.delivered}}</td>
                                                <td class="align-middle">{{relay.bounced}}</td>
                                                <td class="align-middle">{{relay.views}}</td>
                                                <td class="align-middle">{{relay.clicks}}</td>
                                                <td class="align-middle">{{relay.conversions}}</td>
                                                <td class="align-middle">{{relay.profit}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import Swal from 'sweetalert2'
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import ReportService from '../services/ReportService';
    import PmtaRelayGroupService from '../services/PmtaRelayGroupService';
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment';

    export default {
        name: 'PmtaRelaysReport',
        components: {
            Treeselect,
            Breadcrumb,
            Preloader,
            DatePicker
        },
        data() {
            return {
                report: [],
                emptyMessage: 'Select dates and get a report.',
                relayGroupList: null,
                filter: {
                    relayGroup: null,
                    fromDate: null,
                    toDate: null,
                    orderBy: 'host',
                    asc: true,
                    isVps: null
                },
                relayTypeSelect: [
                    {id: 'all', label: 'All'},
                    {id: true, label: 'VPS'},
                    {id: false, label: 'Net'}
                ],
                loading: false,
                waitRelay: null,
                relayReport: [],
                isAdmin: false,
                range: [moment().subtract(7, 'days').toDate(), moment().toDate()],
                datePickerConf: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
        },
        methods: {
            loadRelayGroupList({callback}) {
                PmtaRelayGroupService.getGroupSelect().then(response => {
                    this.relayGroupList = response.data['hydra:member'].map(group => {
                        return {id: group.id, label: group.name}
                    });
                    callback();
                });
            },
            getRelaysReport: function () {
                this.filter.fromDate = moment(this.range[0]).format('YYYY-MM-DD');
                this.filter.toDate = moment(this.range[1]).format('YYYY-MM-DD');
                this.loading = true;
                ReportService.getPmtaRelaysReport(JSON.stringify(this.filter)).then(response => {
                    if (response.status !== 200) {
                        Swal({
                            type: 'error',
                            title: 'Error',
                            text: (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                        });
                        this.loading = false;
                        return;
                    }
                    this.report = response.data.report;
                    this.emptyMessage = 'No data found.';
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            },
            getRelayReport: async function (relayId, relayHost) {
                this.waitRelay = relayId;
                this.filter['relayId'] = relayId;
                let swalHtml = '';
                await ReportService.getPmtaRelayReport(JSON.stringify(this.filter)).then(response => {
                    this.waitRelay = null;
                    if(response.status === 200){
                        this.relayReport = response.data.report;
                    } else {
                        swalHtml = (response.data.error=== undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                    }
                }).catch(error => {
                    this.waitRelay = null;
                    swalHtml = error;
                });
                await Swal({
                    width: '80%',
                    title: 'Report for relay: ' + relayHost,
                    html: swalHtml === '' ? document.getElementById('relayReportHtml').innerHTML : swalHtml,
                    confirmButtonText: 'Close',
                });
            },
            tableOrdering(field) {
                if (this.filter.orderBy === field) {
                    this.filter.asc = !this.filter.asc;
                } else {
                    this.filter.orderBy = field;
                    this.filter.asc = false;
                }
                this.getRelaysReport();
            },
        }
    }
</script>

<style scoped>
    tbody {
        font-size: 14px;
        font-family: Arial, serif;
    }

    #relay-host {
        color: #146da6;
        font-weight: 400;
    }
</style>
